import React from 'react';

import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { CloseAccountModal } from './close-account/CloseAccountModal';
import { PurposeSection } from './PurposeSection';

import { ModalSection } from '../../../../Shared/components-v2/modal-section/ModalSection';
import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { EnvelopeAccountSettingsModalQuery } from '../graphql/accountSettingsModal.generated';
import { formatLegalAccountType } from '../helper';

type CashAccount = EnvelopeAccountSettingsModalQuery['envelopeAccount'] & { __typename: 'CashAccount' };

type CashAccountSettingsProps = {
  envelopeAccount: CashAccount;
};

export const CashAccountSettings: React.FC<CashAccountSettingsProps> = ({ envelopeAccount }) => {
  const { legalAccount } = envelopeAccount;
  const legalAccountType = formatLegalAccountType(legalAccount);
  const hasBeneficiaries = legalAccount.primaryBeneficiaries.length > 0;

  return (
    <Box css={{ display: 'grid', gap: 'space.200' }}>
      <ModalSection header="Account details">
        <ModalSectionRow>
          <ModalSectionRow.LeadingContent>
            <Text>Account type</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{legalAccountType}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
        {!hasBeneficiaries && (
          <ModalSectionRow>
            <ModalSectionRow.LeadingContent>
              <Text>Beneficiaries</Text>
            </ModalSectionRow.LeadingContent>
            <ModalSectionRow.TrailingContent>
              <SambaAutoLink to={urlBuilder.getLegalAccounts.absolute()}>Add beneficiary</SambaAutoLink>
            </ModalSectionRow.TrailingContent>
          </ModalSectionRow>
        )}
      </ModalSection>
      <PurposeSection envelopeAccount={envelopeAccount} />
      <CloseAccountModal
        balance={envelopeAccount.balance}
        purposeName={envelopeAccount.envelope.purpose?.name}
        name={envelopeAccount.name}
        legacyAccountId={envelopeAccount.legacySubAccountId}
        triggerText="Close account"
      />
    </Box>
  );
};
